(() => {
  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-ani-rail]");
    if (!button) return;
    const rail = document.getElementById(button.getAttribute("data-ani-rail"));
    if (!rail) return;
    const direction = button.getAttribute("data-ani-dir") === "prev" ? -1 : 1;
    rail.scrollBy({ left: direction * rail.clientWidth * 0.8, behavior: "smooth" });
  });
})();
